import React, { FC, useEffect }     from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table }                    from "semantic-ui-react";
import GetMailGroups                from "../../../../../application/usecase/mail/group/GetMailGroups";
import MailGroups                   from "../../../../../domain/mail/group/MailGroups";
import { ResKaState }               from "../../../../../index";
import BottomSection                from "../../../common/layout/BottomSection";
import ListTotalCount               from "../../../common/layout/ListTotalCount";
import MailGroupDeleteButton        from "./MailGroupDeleteButton";
import MailGroupsPagination         from "./MailGroupsPagination";
import MailGroupUpdateFormButton    from "./MailGroupUpdateFormButton";

const MailGroupList: FC = () => {
  const mailGroups: MailGroups = useSelector((state: ResKaState) => state.mailGroups);
  const getMailGroups: GetMailGroups = new GetMailGroups(useDispatch());

  useEffect(() => {
    getMailGroups.execute(mailGroups.pagination.current);
  }, []);

  if (mailGroups.isEmpty()) {
    return <p>メールグループが作成されていません。</p>
  }

  return (
    <>
      <ListTotalCount>{ mailGroups.count.toString() }</ListTotalCount>

      <Table
        striped
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>メールグループ名</Table.HeaderCell>
            <Table.HeaderCell>操作</Table.HeaderCell>
            <Table.HeaderCell>作成日</Table.HeaderCell>
            <Table.HeaderCell>更新日</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {
            mailGroups.toList().map(mailGroup => (
              <Table.Row>
                <Table.Cell>
                  { mailGroup.name.value }
                </Table.Cell>
                <Table.Cell>
                  <MailGroupUpdateFormButton mailGroup={ mailGroup }/>
                  <MailGroupDeleteButton mailGroup={ mailGroup }/>
                </Table.Cell>
                <Table.Cell>
                  { mailGroup.trail.createdAt.toString() }
                </Table.Cell>
                <Table.Cell>
                  { mailGroup.trail.updatedAt.toString() }
                </Table.Cell>
              </Table.Row>
            ))
          }
        </Table.Body>
      </Table>

      <BottomSection>
        <MailGroupsPagination/>
      </BottomSection>
    </>
  );
};

export default MailGroupList;
